import { addressSuggestionNavigation } from 'redux/modules/address-suggestion/selectors';

export const getAddressBySuggestionCanNavigateBack = state => {
  const navigation = addressSuggestionNavigation(state);
  return navigation.length > 1;
};
